import { Component, OnInit } from '@angular/core';
import { UserService, BaseComponent } from '@bt/core';
import { GetSessionModel } from '@bt/core/models/getSession.model';
import { NotifierService } from 'angular-notifier';
import { SessionFilter } from '@bt/core/models/sessionFilter.model';

@Component({
  selector: 'app-sessions',
  templateUrl: './sessions.component.html',
  styleUrls: ['./sessions.component.scss']
})
export class SessionsComponent extends BaseComponent {

  public sessions: GetSessionModel[];
  public filter: SessionFilter;
  constructor(private usersService: UserService, private notifierService: NotifierService) {
    super();
    this.sessions = new Array<GetSessionModel>();
    this.filter = new SessionFilter();
    this.filter.email = "";
   }

  ngOnInit() {
    this.getSessions();
  }

  public getSessions(){
    this.setLoading(true);
    this.usersService.getSessions(this.filter)
    .then((resp: any) => {
      this.sessions = resp.data;
      this.setLoading(false);
    })
    .catch((error: any) => {
      this.setLoading(false);
      this.notifierService.notify('error', error.error.Msgs[0]);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/sessions/sessions.component.ts